import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-blue-small-logos.component.scss';
import Slider from '../slider/slider.component';
var BannerHeroBlueSmallLogos = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroBlueSmallLogos, _super);
    function BannerHeroBlueSmallLogos(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroBlueSmallLogos.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerHeroBlueSmallLogos.prototype.bindEvents = function () { };
    return BannerHeroBlueSmallLogos;
}(Base));
export { BannerHeroBlueSmallLogos };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-blue-small-logos/banner-hero-blue-small-logos.component.ts
// module id = 127
// module chunks = 0